import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { message, Spin } from "antd";
import { getQrLocationPublicById, getQRdetail } from "../../endpoints/API";
import LocationDetail from "./LocationDetail";

const QrDetailsPage = () => {
    const { qr_id } = useParams();

    const [loading, setLoading] = useState(true);
    const [selectedQRLocationDetail, setSelectedQRLocationDetail] = useState(null);
    const [selectedLocationData, setSelectedLocationData] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);

    // Fetch list of locations belonging to this QR
    const fetchQRDetails = async () => {
        try {
            const res = await getQrLocationPublicById(qr_id);
            setSelectedQRLocationDetail(res.data.locations);
        } catch (err) {
            console.error(err);
            message.error("Invalid QR link");
        } finally {
            setLoading(false);
        }
    };

    const handleLocationClick = async (locationId, dates = null) => {
        setDetailLoading(true);
        let start_date = "";
        let end_date = "";

        if (dates && dates.length === 2) {
            start_date = dates[0]?.format("YYYY-MM-DD");
            end_date = dates[1]?.format("YYYY-MM-DD");
        }

        console.log("asdasdasdasa",start_date,end_date)

        try {
            const res = await getQRdetail(locationId, start_date, end_date);
            setSelectedLocationData(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setDetailLoading(false);
        }
    };


    useEffect(() => {
        fetchQRDetails();
    }, []);

    if (loading) {
        return (
            <div className="flex justify-center mt-20">
                <Spin size="large" />
            </div>
        );
    }

    // If QR id is invalid
    if (!selectedQRLocationDetail) {
        return (
            <div className="text-center mt-20 text-xl text-red-500">
                Invalid or expired QR code.
            </div>
        );
    }

    return (
        <div style={{ maxWidth: "900px", margin: "0 auto", padding: "1rem" }}>
            <LocationDetail
                selectedQRLocationDetail={selectedQRLocationDetail}
                setSelectedQRLocationDetail={setSelectedQRLocationDetail}
                detailLoading={detailLoading}
                handleLocationClick={handleLocationClick}
                selectedLocationData={selectedLocationData}
                setSelectedLocationData={setSelectedLocationData}
            />
        </div>
    );
};

export default QrDetailsPage;
